import * as actionTypes from "./actionTypes";
import { CrowdEventLogFilter } from "../../components/Utils/Models/api";

export const setCrowdFilter = (filter: CrowdEventLogFilter) => {
  return {
    type: actionTypes.SET_CROWD_FILTER,
    filter,
  };
};
